import React from 'react';
import CloseIcon from 'views/components/icons/Close';
import cn from 'classnames';
import ToggleButton from 'views/components/ToggleButton';
import { capacityOnRamps } from './selectOptions';
import DropdownStyles from '../DropdownStyles';
import { getTheme } from 'utils/SelectTheme';
import Select from 'react-select';

const OnRamps = ({
  // onChangeMetroTagInformation,
  onRampsOptions,
  onRampConfiguration,
  setOnRampConfiguration,
  setSelectedOnRamps,
  selectedOnRamps,
  setCapOnRamp,
  capOnRamp,
  updateLayersConfiguration,
}) => {
  const updateConfiguration = (newValue) => {
    setOnRampConfiguration({ ...onRampConfiguration, ...newValue });
    updateLayersConfiguration({ ...newValue });
  };

  const updateSelectedOnRamps = (onRamp) => {
    const exists = selectedOnRamps.some((selected) => selected === onRamp);
    const newValue = exists ? selectedOnRamps.filter((selected) => selected !== onRamp) : [...selectedOnRamps, onRamp];
    setSelectedOnRamps(newValue);
    updateLayersConfiguration({ selectedOnRamps: newValue });
  };

  const changeCampOnRamp = (value) => {
    setCapOnRamp(value);
    updateLayersConfiguration({ capOnRamp: value });
  };

  return (
    <div className={cn('onRamps-view')} data-testid={'onRamps-menu'}>
      <ul>
        <li>
          <span className="subsection-title">Show for:</span>
          <div className="select-wrapper">
            <Select
              classNamePrefix="select"
              value={capacityOnRamps.find((i) => i.value === capOnRamp)}
              onChange={(e) => changeCampOnRamp(e.value)}
              options={capacityOnRamps}
              isSearchable={false}
              theme={getTheme}
              menuPlacement={'auto'}
              menuPosition={'fixed'}
              styles={DropdownStyles}
            />
          </div>
        </li>
      </ul>
      <ul>
        <div className={'separator-line'} />
        <li onClick={() => updateConfiguration({ showHeatMap: !onRampConfiguration.showHeatMap })}>
          <span>Show Heat Map</span>
          <ToggleButton
            small
            checked={onRampConfiguration.showHeatMap}
            onToggled={() => updateConfiguration({ showHeatMap: !onRampConfiguration.showHeatMap })}
          />
        </li>
      </ul>
      <ul>
        <li onClick={() => updateConfiguration({ showCount: !onRampConfiguration.showCount })}>
          <span>Show On-Ramp Count</span>
          <ToggleButton small checked={onRampConfiguration.showCount} onToggled={() => updateConfiguration({ showCount: !onRampConfiguration.showCount })} />
        </li>
      </ul>
      <ul>
        <li onClick={() => updateConfiguration({ showMarketShare: !onRampConfiguration.showMarketShare })}>
          <span>Show Market Share (%)</span>
          <ToggleButton
            small
            checked={onRampConfiguration.showMarketShare}
            onToggled={() => updateConfiguration({ showMarketShare: !onRampConfiguration.showMarketShare })}
          />
        </li>
      </ul>
      <ul className={cn('actions-list', { disabled: !selectedOnRamps.length })}>
        <li onClick={() => setSelectedOnRamps([])}>
          <p>Clear Selection</p>
          <CloseIcon width={10} height={10} color="#000000" />
        </li>
      </ul>
      <div className={'separator-line'} />
      <ul className={'actions-list'}>
        {!!onRampsOptions?.length &&
          onRampsOptions.map((onRamp) => (
            <div key={`onRamp-list-${onRamp}`}>
              <li onClick={() => updateSelectedOnRamps(onRamp)} className={cn({ selected: selectedOnRamps.includes(onRamp) })}>
                {onRamp}
              </li>
            </div>
          ))}
      </ul>
    </div>
  );
};

export default OnRamps;
